(() => {
  const observers = new Map();
  const init = () => {
    for (const [row, observer] of observers) {
      if (!row.isConnected) { observer.disconnect(); observers.delete(row); }
    }
    document.querySelectorAll('.footer__follow-row').forEach(row => {
      const shop = row.querySelector('shop-follow-button');
      if (!shop || observers.has(row)) return;
      let paintedButton;
      const sync = () => {
        const button = shop.shadowRoot?.querySelector('button');
        if (button && paintedButton !== button) {
          if (paintedButton) observer.unobserve(paintedButton);
          paintedButton = button;
          observer.observe(button);
        }
        const height = (button || shop).getBoundingClientRect().height;
        if (height > 0) row.style.setProperty('--sv-follow-height', `${height}px`);
      };
      const observer = new ResizeObserver(sync);
      observers.set(row, observer);
      observer.observe(shop);
      customElements.whenDefined('shop-follow-button').then(() => {
        if (row.isConnected) sync();
      });
      sync();
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
})();
